import React from 'react';

const SimpleStar = () => {
	return (
		<svg
			className='star'
			width='12'
			height='11'
			viewBox='0 0 12 11'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M6 0L7.80568 3.5147L11.7063 4.1459L8.92165 6.9493L9.52671 10.8541L6 9.072L2.47329 10.8541L3.07835 6.9493L0.293661 4.1459L4.19432 3.5147L6 0Z'
				fill='#EEEDF5'
			/>
		</svg>
	);
};

const FilledStar = () => {
	return (
		<svg
			className='star'
			width='12'
			height='11'
			viewBox='0 0 12 11'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M6 0L7.80568 3.5147L11.7063 4.1459L8.92165 6.9493L9.52671 10.8541L6 9.072L2.47329 10.8541L3.07835 6.9493L0.293661 4.1459L4.19432 3.5147L6 0Z'
				fill='#F2C94C'
			/>
		</svg>
	);
};

const Star = props => {
	if (props.flag) {
		return <FilledStar />;
	} else {
		return <SimpleStar />;
	}
};

export default Star;
